module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAFYwwxmAAAAAXNSR0IArs4c6QAAAKVJREFUOBGtkIENgDAIBHUI3X+JbuAIJk7hDNrXPiGF0sbYpKHA8UCnqTpL5b8uoruXkWCTYNXGB62UXiUiARJMPP7MaGBFIWXI2wSAQBQCiFZcwQAEI4viFAHI6U5N1kDm51pK9XZGSfckHEIsAMwvYuxXiynYxNt3uJkWgiD8T6crhDHxJ70uXSE9XgRHOa3hvnXxkQnckeldMR1cs3OWiybD5wbj4DTBLT+a0wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_tick.png
// module id = ZzOX
// module chunks = 1